
import Vue from 'vue'
import { VProgressLinear } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcFooter',
  components: {
    VProgressLinear,
  },
  props: {
    loading: { type: Boolean, default: false },
  },
  data: () => ({}),
  methods: {},
})
